module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMjU2IDM4NGE2NCA2NCAwIDEgMCAwIDEyOCA2NCA2NCAwIDAgMCAwLTEyOHogbS0yNTYgMGE2NCA2NCAwIDEgMCAwIDEyOCA2NCA2NCAwIDAgMCAwLTEyOHogbS0yNTYgMGE2NCA2NCAwIDEgMCAwIDEyOCA2NCA2NCAwIDAgMCAwLTEyOHoiIGZpbGw9IiMwIiBwLWlkPSI0MjM5Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Pending-filled.svg
// module id = VOWw
// module chunks = 74